import React from "react";
import { NonMedicalCategoryDistribution } from "@/routes/(pharma)/_layout/inventory/-data/model";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";
import { PieChart, Pie, LabelList, Cell } from "recharts";
import { CategoryWiseDistribution } from "@/gen/inventory/common_pb";

interface NonMedicalCategoryPieChartProps {
  data: CategoryWiseDistribution[];
}

const PIE_COLORS = [
  "#2563eb", // blue-600
  "#1d4ed8", // blue-700
  "#3b82f6", // blue-500
  "#60a5fa", // blue-400
  "#93c5fd", // blue-300
  "#bfdbfe", // blue-200
  "#dbeafe", // blue-100
];

const chartConfig = {
  total_products: {
    label: "Total Products",
    color: PIE_COLORS[0],
  },
};

const NonMedicalCategoryPieChart: React.FC<NonMedicalCategoryPieChartProps> = ({ data }) => {
  return (
    <Card className="bg-[#FCFCFC] flex flex-col h-full">
      <CardHeader className="items-center pb-0">
        <CardTitle>Non-Medical Category Distribution</CardTitle>
        <CardDescription>Current non-medical inventory distribution by category</CardDescription>
      </CardHeader>
      <CardContent className="flex-1 pb-0">
        <ChartContainer
          config={chartConfig}
          className="mx-auto aspect-square max-h-[250px] [&_.recharts-text]:fill-background"
        >
          <PieChart>
            <ChartTooltip content={<ChartTooltipContent nameKey="totalItems" hideLabel />} />
            <Pie data={data} dataKey="totalItems" nameKey="category" stroke="none">
              {data.map((entry, idx) => (
                <Cell key={`cell-${idx}`} fill={PIE_COLORS[idx % PIE_COLORS.length]} />
              ))}
              <LabelList
                dataKey="category"
                className="fill-background"
                stroke="none"
                fontSize={12}
                formatter={(value: string) => String(value)}
              />
            </Pie>
          </PieChart>
        </ChartContainer>
      </CardContent>
      {/* <CardFooter className="flex-col gap-2 text-sm">
        <div className="leading-none text-muted-foreground">
          Showing non-medical inventory distribution by category on your available stock
        </div>
      </CardFooter> */}
    </Card>
  );
};

export default NonMedicalCategoryPieChart; 